//const BASE_URL = "https://hms.oakya.tech";

const  BASE_URL = "https://homeservices.oakyaitservices.in/api";  

//const  BASE_URL = "http://192.168.1.143/oakya_homeservices";  
const API_URLS = {
  getCategoryImages: {
    url: `${BASE_URL}/service_category`
  },
  getsevicesImages: {
    url: `${BASE_URL}/service/`
  },
  createServiceCategory: {
    url: `${BASE_URL}/service_category/create.php`,
    method: 'POST',
  },
  getAllServiceCategories: {
    url: `${BASE_URL}/service_category/admincategory.php`,
    method: 'GET',
  },
  updateServiceCategory: {
    url: `${BASE_URL}/service_category/update.php`,
    method: 'POST',
  },
  deleteServiceCategory: {
    url: `${BASE_URL}/service_category/delete.php`,
    method: 'DELETE',
  },
  getServicesByCategoryId: (category_id) => ({
    url: `${BASE_URL}/services/getByCategory.php?category_id=${category_id}`,
    method: 'GET',
  }),
  createService: {
    url: `${BASE_URL}/service/create.php`,
    method: 'POST',
  },
  getAllServices: {
    url: `${BASE_URL}/service/adminservice.php`,    
    method: 'GET',
  },
  getServiceById: {
    url: `${BASE_URL}/service/retrieve.php`,    
    method: 'POST',
  },
  updateService:{
    url: `${BASE_URL}/service/update.php`,
    method: 'POST',
  },
  deleteService:{
    url: `${BASE_URL}/service/delete.php`,       
    method: 'DELETE',
  },

  getCategories: {
    url: `${BASE_URL}/categories/getAll.php`,
    method: 'GET',
  },

  createAvailability: {
    url: `${BASE_URL}/availability/create.php`,
    method: 'POST',
  },
  getAllAvailability: {
    url: `${BASE_URL}/availability/retrieve.php`,
    method: 'GET',
  },
  updateAvailability: (id) => ({
    url: `${BASE_URL}/availability/update.php?id=${id}`,
    method: 'PUT',
  }),
  deleteAvailability: (id) => ({
    url: `${BASE_URL}/availability/delete.php?id=${id}`,
    method: 'DELETE',
  }),
  bookService: {
    url: `${BASE_URL}/booking/bookService.php`,
    method: 'POST',
  },
  getBookingReport: {
    url: `${BASE_URL}/booking/bookingretrieve.php`,
    method: 'GET',
  },
  getTodayBookingReport: {
    url: `${BASE_URL}/booking/today.php`,
    method: 'POST',
  },
  addServiceProvider: {
    url: `${BASE_URL}/service_provider/create.php`,    
    method: 'POST',
  },
  getServiceProvidersAdmin: {
    url: `${BASE_URL}/service_provider/adminprovider.php`,  
    method: 'GET',
  },
  getCustomerReport: {
    url: `${BASE_URL}/user/retrieve.php`,
    method: 'GET',
  },

updateProviderAdmin:{
  url: `${BASE_URL}/service_provider/update.php`,
  method: 'POST',
},
  getCustomerReportById: {
    url: `${BASE_URL}/user/retrieve.php`,
    method: 'POST',
  },
  createAdmin: {
    url: `${BASE_URL}/admin/create.php`,
    method: 'POST',
  },
  adminLogin: {
    url: `${BASE_URL}/admin/login.php`,
    method: 'POST',
  },
  customerRegister: {
    url: `${BASE_URL}/customers/register.php`,
    method: 'POST',
  },
  customerOTPVerification: {
    url: `${BASE_URL}/customers/verifyOtp.php`,
    method: 'POST',
  },
  updateUserDetails: (id) => ({
    url: `${BASE_URL}/customers/updateProfile.php?id=${id}`,
    method: 'PUT',
  }),
  fetchUserDetails: (user_id) => ({
    url: `${BASE_URL}/customers/fetchProfile.php?user_id=${user_id}`,
    method: 'GET',
  }),
  bookingReportAnalysis: {
    url: `${BASE_URL}/booking/analysis.php`,
    method: 'GET',
  },
  getBookingCounts:{
    url: `${BASE_URL}/analytics/count.php`,
    method: 'GET',
  },
  getBookingDetails:{
    url: `${BASE_URL}/booking/retrieve.php`,
    method: 'POST',
  },

getProviderNames:{
  url: `${BASE_URL}/service_provider/retrieve.php`,
  method: 'PUT',
},

getProviderDetailsById:{
  url: `${BASE_URL}/service_provider/retrieve.php`,
  method: 'POST',
},
getAllProviderDetails:{
  url: `${BASE_URL}/service_provider/retrieve.php`,
  method: 'GET',
},

updateBookingDetails:{ 
  url: `${BASE_URL}/booking/update.php`,
  method: 'PUT',
},
//provider api's
ProviderLogin: {
  url: `${BASE_URL}/service_provider/login.php`,
  method: 'POST',
},
providerTodayBookingReport:{
  url: `${BASE_URL}/booking/today.php`,
  method: 'PUT',
},
providerBookingsHistoryReport:{
  url: `${BASE_URL}/booking/bookingretrieve.php`,
  method: 'PUT',
},
adminupdateprovider:{
  url: `${BASE_URL}/service_provider/update.php`,
  method: 'POST',
},
providerbasedUsers:{
  url: `${BASE_URL}/booking/user.php`,
  method: 'POST',
},

//service provider profile

getProviderDetailsProfile:{
  url: `${BASE_URL}/service_provider/retrieve.php`,
  method: 'POST',
},


updateProviderDetails:{
  url: `${BASE_URL}/service_provider/update.php`,
  method: 'POST',
},



updateviewOrderDetails:{
  url: `${BASE_URL}/booking/view_order.php`,
  method: 'POST',
}


};
export default API_URLS;



